const popups = {
  trigersToggle: [
    {
      name: "filters",
      open: [document.getElementById("openFilters")] as HTMLElement[],
      popup: document.getElementById("filters"),
      close: document.getElementById("closeFilters") as HTMLElement,
      overlay: true,
    },
    {
      name: "mobMenu",
      open: [document.getElementById("openMobMenu")] as HTMLElement[],
      popup: document.getElementById("mobMenu"),
      close: document.getElementById("closeMobMenu") as HTMLElement,
      overlay: true,
    },
    {
      name: "search",
      open: [document.getElementById("openMobSearch")] as HTMLElement[],
      popup: document.getElementById("mobSearch"),
      close: document.getElementById("closeMobSearch") as HTMLElement,
      overlay: true,
    },
    {
      name: "enquiry",
      open: [document.getElementById("openProdEnquiry")] as HTMLElement[],
      popup: document.getElementById("prodEnquiry"),
      close: document.getElementById("closeProdEnquiry") as HTMLElement,
      overlay: true,
    }
  ],

  overlay: document.getElementById("overlay")! as HTMLElement,
  close: document.querySelectorAll(".jsClose"),
  activClasse: [] as HTMLElement[],
  menuAdvert: document.getElementById("phoneAdvert"),

  init() {
    this.openPopupToggle()
    this.overlayClose()
  },

  overlayClose() {
    this.overlay.addEventListener("click", () => {
      this.overlay.classList.remove("activeClass")
      document.documentElement.style.overflow = "auto"
      document.body.classList.remove("activeClass")
      this.closeAll()
    })
  },

  setOverlay(open: HTMLElement | boolean, popup: HTMLElement | null, triger: HTMLElement, overlay = false) {
    if (open && popup && triger) {
      this.closeAll()
      this.overlay.classList.remove("activeClass")
      if (overlay) {
        this.overlay.classList.add("activeClass")
      }

      document.documentElement.style.overflow = "hidden"
      document.body.classList.add("activeClass")

      popup.classList.add("activeClass")
      triger.dataset.open = "true"
      triger.classList.add("activeClass")
      this.activClasse.push(popup)
      this.activClasse.push(triger)
    } else {
      this.overlay.classList.remove("activeClass")
      triger.dataset.open = "false"

      document.documentElement.style.overflow = "auto"
      document.body.classList.remove("activeClass")

      this.closeAll()
    }
  },
  closeAll() {
    this.activClasse.forEach((item) => {
      item.classList.remove("activeClass")
      item.dataset.open = "false"
    })
    this.activClasse = []
  },
  openPopupToggle() {
    this.trigersToggle.forEach((item, index) => {
      if (item["open"].length > 0) {
        item["open"].forEach((el) => {
          if (item["popup"] && el) {
            item["popup"].classList.add("init")
            el.addEventListener("click", (e) => {
              e.preventDefault()
              if (el.dataset.open === "false") {
                this.setOverlay(true, item["popup"], el, item["overlay"])
              } else {
                this.setOverlay(false, item["popup"], el)
              }
            })
          }
        })

        if (item["close"] && typeof item["close"] === "object") {
          item["close"].addEventListener("click", () => {
            item["open"].forEach((el: HTMLElement) => {
              this.setOverlay(false, item["popup"], el)
            })
          })
        }
      }
    })
  },
}

export default popups
